import { __, __x, __nx, __N } from 'JIX/gettext.js';

export default {
    statusOnline: () =>
        __('Vil gerne kontaktes'),
    statusOffline: () =>
        __('Vil ikke kontaktes'),
};
